import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { PartyId, TPartyIdCodec } from "../PartyId";

export const PartyMemberCreateForm: TFormCodec<TPartyIdCodec, TEmptyObjectCodec> = form(
    PartyId,
    EmptyObject,
);

export type TPartyMemberCreateFormCodec = typeof PartyMemberCreateForm;
export type TPartyMemberCreateForm = TTypeOfCodec<TPartyMemberCreateFormCodec>;
